import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IndicatorIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 12 12" {...props}>
            <circle cx="6" cy="6" r="6" fill="currentColor" />
        </SvgIcon>
    );
};
